module.exports = __webpack_public_path__ + "static/media/sustainable_tablet.1e751ffc.jpg";